<template>
  <v-sheet class="promotion" style="height: calc(100vh - 140px)">
    <v-card-text class="px-0 custom_field_height">
      <v-row>
        <v-col md="3" class="py-0 pr-0" style="max-width: 340px">
          <label for="segment_name" class="custom-form-label" style="font-weight: 600">Filter By Date
            Range</label>
          <DateRangePicker hide-details class="mt-3" v-model="range" :disabled="pageLoading" :loading="pageLoading"
            id="item-sale-duration" placeholder="Date Range" :clearable="false"></DateRangePicker>
        </v-col>
        <!-- <v-col class="py-0 pr-0" style="max-width: 180px; width: 180px">
                    <label for="segment_name" class="custom-form-label" style="font-weight: 600">Filter by Paid
                        Month</label>
                    <AutoCompleteInput class="mt-3" hide-details :disabled="pageLoading" :loading="pageLoading"
                        :items="months" id="segment" item-text="name" item-value="value" v-model="search_month"
                        placeholder="Select Month">
                    </AutoCompleteInput>
                </v-col>
                <v-col class="py-0 pr-0" style="max-width: 180px; width: 180px">
                    <label for="segment_name" class="custom-form-label" style="font-weight: 600">Filter by Paid
                        Year</label>
                    <AutoCompleteInput class="mt-3" hide-details :disabled="pageLoading" :loading="pageLoading"
                        :items="yearlist" id="segment" v-model="search_year" placeholder="Select Year">
                    </AutoCompleteInput>
                </v-col> -->
        <v-col md="3" class="mt-5 px-0">
          <v-flex>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn style="max-width: 10px" color="blue darken-4" v-on="on" v-bind="attrs" depressed tile
                  @click="searchPromotions" class="ml-2 white--text me-1 px-1">
                  <v-icon>mdi-magnify</v-icon></v-btn>
              </template>
              <span>Filter</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="red darken-4" v-on="on" v-bind="attrs" depressed tile v-on:click="reset"
                  class="ml-2 white--text me-1">Reset
                </v-btn>
              </template>
              <span>Reset </span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="blue darken-4" v-on="on" v-bind="attrs" depressed tile :disabled="isNotData"
                  v-on:click="downloadPDF" class="ml-2 white--text me-1">Download
                </v-btn>
              </template>
              <span>Download </span>
            </v-tooltip>
          </v-flex>
        </v-col>
        <v-col class="mt-5 justify-content-end ps-0">
          <v-flex class="d-flex justify-content-end">

          </v-flex>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- border: 1px solid #c3c5cd; -->
    <template v-if="!isNotData"> <v-col class="py-0 d-flex justify-center">
        <h4 style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">
          Profit and Loss
        </h4>


      </v-col>
      <v-col cols="12" class="py-0 d-flex justify-center">
        <h6 class="mb-0">{{ this.title }}</h6>
      </v-col></template>


    <v-card class="pa-4 align-center justify-center mx-auto" style="max-width: 70%; " v-if="!isNotData">
      <v-row>

        <!-- <v-col cols="12" class="py-0 d-flex justify-center">
                    <img src="https://bthrust-fsm.s3.ap-southeast-1.amazonaws.com/files/image/treasure-header---.jpg" alt="logo" style="margin-top:25px;"> 
                </v-col> -->

        <v-col cols="12">
          <hr style="border: 3px solid #c3c5cd;">
          <v-simple-table dense>

            <tbody>
              <tr>
                <td class="font-weight-bold"></td>
                <td align="end" class="font-weight-bold"> Total </td>
              </tr>

              <tr>
                <td class="font-weight-regular"> Income </td>
                <td class="font-weight-bold"></td>
              </tr>

              <tr>

                <td class="font-weight-bold"> Total Income </td>
                <td align="end">: <b>{{ formatMoney(totalRevenue) }}</b></td>
              </tr>
              

              <tr>
                <td :colspan="2" style="padding: 0;">
                  <hr style="border: 0.4px solid black; margin: 0;">
                </td>
              </tr>
              <tr>
                <td class="font-weight-regular"> Purchase order </td>
                <td class="font-weight-bold"></td>
              </tr>
              <tr>
                <td class="font-weight-bold">Total Purchase order</td>
                <td align="end">: <b>{{ formatMoney(totalPOS) }}</b></td>

              </tr>

              <tr>
                <td :colspan="2" style="padding: 0;">
                  <hr style="border: 0.4px solid black; margin: 0;">
                </td>
              </tr>
              <tr>
                <td class="font-weight-regular"> Cost of Sales </td>
                <td class="font-weight-bold"></td>
              </tr>
              <tr>
                <td class="font-weight-bold">Total Cost of Sale</td>
                <td align="end">: <b>{{ formatMoney(totalCos) }}</b></td>

              </tr>
              <tr>
                <td :colspan="2" style="padding: 0;">
                  <hr style="border: 0.4px solid black; margin: 0;">
                </td>
              </tr>
              <tr>
                <td class="m-1"> GROSS PROFIT</td>
                <td align="end">: <b>{{ formatMoney(grossProfit) }}</b></td>

              </tr>

              <tr>
                <td class="m-2 font-large"> EXPENSE</td>
                <td class="m-2 font-large"></td>
                <!-- <td align="end">: <b>{{ formatMoney(totalExpenses) }}</b></td> -->

              </tr>
              <tr >
                <td class="font-weight-bold">Total Salary</td>
                <td align="end"> : <b>{{ formatMoney(totalSalaries) }}</b></td>
              </tr>
              <!-- <tr>
                <td :colspan="2" style="padding: 0;">
                  <hr style="border: 0.4px solid black; margin: 0;">
                </td>
              </tr> -->
              <template v-if="utlities">
                <tr>
                  <td class="font-weight-regular" colspan="2">Utilities</td>
                </tr>
                <tr v-for="utlity in utlities" :key="utlity.id">
                  <td align="start" width="80%">{{ utlity.title != null ? utlity.title : '(miscellaneous)' }}</td>
                  <td align="end">: {{ formatMoney(utlity.amount) }}</td>

                </tr>

                <tr>
                  <td class="font-weight-bold">Total Utilities</td>
                  <td align="end"> : <b>{{ formatMoney(totalUtilities) }}</b></td>
                </tr>
                <!-- <tr>
                  <td :colspan="2" style="padding: 0;">
                    <hr style="border: 0.4px solid black; margin: 0;">
                  </td>
                </tr> -->

              </template>


              <template v-if="rent">
                <tr>
                  <td class="font-weight-regular" colspan="2">Rents</td>
                </tr>
                <!-- <tr v-for="r in rent" :key="r.id">
                                    <td align="start" width="80%">{{ r.title }}</td>
                                    <td align="end">: {{ formatMoney(r.amount) }}</td>

                                </tr> -->

                <tr>
                  <td class="font-weight-bold">Total Rent</td>
                  <td align="end"> : <b>{{ formatMoney(totalRent) }}</b> </td>
                </tr>
                <tr>
                  <td :colspan="2" style="padding: 0;">
                    <hr style="border: 0.4px solid black; margin: 0;">
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Total Expenses</td>
                  <td align="end"> : <b>{{ formatMoney(totalExpenses) }}</b></td>
                </tr>
                <tr>
                  <td class="font-weight-regular">Total Other Expenses <span class="font-sm ">(Expenses + COS + POS)</span>
                  </td>

                  <td align="end"> : <b>{{ formatMoney(totalOtherExpenses) }}</b></td>
                </tr>
                <tr>
                  <td :colspan="2" style="padding: 0;">
                    <hr style="border: 0.4px solid black; margin: 0;">
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold mb-4">Net Earning</td>
                  <td align="end"> : {{ formatMoney(total) }}</td>
                </tr>

              </template>


            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card>

    <v-row v-else>
      <v-col cols="12" class="mt-5 py-0 d-flex justify-center">
        <p class="m-0 text-center">
          <img width="60" :src="$assetURL('media/error/empty.png')" class="row-not-found-image mr-4" />
          Uhh... We don't have records at the moment.
        </p>
      </v-col>
    </v-row>

    <Dialog :dialog="dialog" :dialogWidth="900">
      <template v-slot:title>Remark </template>
      <template v-slot:body>
        <v-row class="delete-dialog">
          <v-col md="10" class="py-0 my-auto">
            <p class="btx-p m-0"><b class="red--text text--lighten-1"></b>{{ stripHtmlTags(text) }}</p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn depressed tile @click="dialog = false"> Close </v-btn>
      </template>
    </Dialog>
  </v-sheet>
</template>
  <script>
  import Dialog from "@/view/components/Dialog";
  import { GET_SALES_REPORT } from "@/core/lib/payment.lib";
 
  import { SET_ERROR } from "@/core/services/store/common.module";
  import DateRangePicker from "@/view/components/DateRangePicker";
  // import PaymentHeader from "@/view/components/PaymentHeader.vue";
//   import { SET_MESSAGE } from "@/core/services/store/common.module";
//   import { PATCH } from "@/core/services/store/request.module";
  import { SearchEventBus } from "@/core/lib/search.lib";

  
//   import { POST } from "@/core/services/store/request.module";
  
  import {
    SET_SEARCH_TITLE,
    SET_SEARCH_MODEL,
    SET_SEARCH_BAR,
    BEFORE_DESTROY,
  } from "@/core/services/store/listing.module";
  import { mapGetters } from "vuex";
//   import { format } from "date-fns";
//   import AutoCompleteInput from "@/view/components/AutoCompleteInput";
  import { formatMoney } from "accounting-js";
  import JwtService from "@/core/services/jwt.service";

  import moment from "moment-timezone";   
 
  export default {
    name: "sales-report",
    title: "Sales Report",
   
    data() {
      return { 
        list: [],
        dialog: false,
        isNotData: false,
        text: '',
        rent: [],
        utlities: [],
        range: [
          moment().startOf('month').format('YYYY-MM-DD'),
          moment().endOf('month').format('YYYY-MM-DD')
        ],
        title: 'Sales Report',
        search_month: null,
        search_year: null,
        totalUtilities: 0,
        totalRent: 0,
        totalPayments: 0,
        totalSalaries: 0,
        totalSales: 0,
         totalExpenses: 0,
        totalOtherExpenses:0,
        grossProfit: 0,
        totalRevenue: 0,
        totalPOS: 0,
        total: 0,
        selectedRange: '',
        yearlist: [],
        months: [
          {
            name: "January",
            value: 1,
          },
          {
            name: "February",
            value: 2,
          },
          {
            name: "March",
            value: 3,
          },
          {
            name: "April",
            value: 4,
          },
          {
            name: "May",
            value: 5,
          },
          {
            name: "June",
            value: 6,
          },
          {
            name: "July",
            value: 7,
          },
          {
            name: "August",
            value: 8,
          },
          {
            name: "September",
            value: 9,
          },
          {
            name: "October",
            value: 10,
          },
          {
            name: "November",
            value: 11,
          },
          {
            name: "December",
            value: 12,
          },
        ],
   
      };
    },
    watch: {

    },
    methods: { 
      formatMoney(money) {
        return formatMoney(money, {
          symbol: "RM",
          decimal: ".",
          thousand: ",",
          precision: 2,
          format: "%s%v",
        });
      },
        downloadPDF() {
            let downloadURL = process.env.VUE_APP_API_URL + "sales-report/pdf";
            downloadURL = new URL(downloadURL);
            const token = JwtService.getToken();
            downloadURL.searchParams.append("token", token);
            if (this.range && this.range.length > 0) {
                downloadURL.searchParams.append("start_date", this.range[0]);
                downloadURL.searchParams.append("end_date", this.range[1]);
                downloadURL.searchParams.append("export", 1);
            } else {
                this.$store.commit(SET_ERROR, [{ model: true, message: "Select a date range." }]);
                return;
            }
            window.open(downloadURL, "_blank");
        },
      reset() {
          
              this.range = this.range = [
                  moment().startOf('month').format('YYYY-MM-DD'),
                  moment().endOf('month').format('YYYY-MM-DD')
              ];
         
      this.search_month = null;
      this.isNotData = false;
      this.search_year = null;
      this.getSalesDetails();
    },
  
  
      stripHtmlTags(content) {
        // Create a temporary element to render HTML and strip tags
        const tempElement = document.createElement('div');
        tempElement.innerHTML = content;
        // Get the text content without HTML tags
        return tempElement.textContent || tempElement.innerText || '';
      },
       
      formateTime(param) {
        return moment(param).format("hh:mm A");
      },
     
    
  
      updateAddressPerson(param) { 
        console.log(param);
        
        this.getSalesDetails();
      },
      remarkPop(reason) {
        this.text = reason; 
        this.dialog = true;
      },
      formatedate(param) {
        return moment(param).format("DD/MM/YYYY");
      },
      getColValue(val) {
        if (val.includes(" ")) {
          return val.split(" ").join("_").toLowerCase();
        } else {
          return val.toLowerCase();
        }
      }, 
     
   
      searchPromotions() {
        this.getSalesDetails();
      },
      async getSalesDetails(search = null) { 
        this.isNotData = false;
        try {
          let form = {
            search: search,
            selectstatus: this.selectstatus,
            filter_type: this.filterType,
            search_month: this.search_month,
            search_year: this.search_year,
          };
          if (this.range && this.range.length > 0) {
            const dateRange = {
              start_date: this.range[0],
              end_date: this.range[1],
            };
            form = { ...form, ...dateRange };
          }else{
            this.$store.commit(SET_ERROR, [{ model: true, message: "Please select a date range." }]);
            return;
          }
          this.pageLoading = true;
          const { rows } = await GET_SALES_REPORT(form);
      
          this.totalPayments = rows.totalSales || 0;
          this.totalCos = rows.totalCos || 0;
          this.grossProfit = rows.grossProfit || 0;
          this.totalExpenses = rows.totalExpenses || 0;
          this.totalOtherExpenses = rows.totalOtherExpenses || 0;
          this.totalSalaries = rows.totalSalaries || 0;
          this.totalRevenue = rows.totalRevenue || 0;
          this.totalPOS = rows.totalPOS || 0;
          this.totalUtilities = rows.totalUtilities || 0;
          this.totalRent = rows.totalRent || 0;
          this.totalSales = rows.totalSales || 0;
          this.total = rows.total || 0;
          this.utlities = rows.utilities || [];
          this.rent = rows.rent || [];

          if(this.total == 0){
               this.isNotData   = true;
          }
          
          if (this.range && this.range.length > 0) {

          this.title =  `Sales Report of ${moment(this.range[0]).format('DD MMMM YYYY')} to ${moment(this.range[1]).format('DD MMMM YYYY')}`;
          }
        //   // Emit events for parent components
        //   this.$emit("saveAddress", this.total);
        //   this.$emit("totalPayments", this.totalPayments);
        //   this.$emit("totalRentPaidThisMonth", this.totalRent);
        //   this.$emit("totalUtilities", this.totalUtilities);

        } catch (error) {
          this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
        } finally {
          this.pageLoading = false;
        }
      },
      resetSearch() {
        this.$router
          .replace({
            query: {
              t: new Date().getTime(),
            },
          })
          .then(() => {
            this.$store.dispatch(SET_SEARCH_MODEL, null);
          });
      },
    },
    async mounted() {
      let _this = this;
      SearchEventBus.$on("start-search", (argument) => {
        _this.searchEnabled = false;
        _this.searchParam = argument;
        if (_this.searchParam) {
          _this.searchEnabled = true;
        }
        this.getSalesDetails(argument);
      });
      SearchEventBus.$emit("search-template", true);
  
      this.getSalesDetails();
      this.sequence = 0;
      this.$store.dispatch(SET_SEARCH_BAR, true);
      this.$store.dispatch(SET_SEARCH_TITLE, "Sales & Profit Report");
    },
    beforeDestroy() {
      this.$store.dispatch(BEFORE_DESTROY);
    },
    components: {
  
      Dialog,
      DateRangePicker, 
    //   AutoCompleteInput,
    },
    computed: {
      ...mapGetters(["listingSearch"]),
        
//   range: {
//     get() {
//         console.log(moment().startOf('month').format('DD/MM/YYYY') + '-' +  moment().endOf('month').format('DD/MM/YYYY'));
        
//       return this.selectedRange || `${moment().startOf('month').format('DD/MM/YYYY')} - ${moment().endOf('month').format('DD/MM/YYYY')}`;
//     },
//     set(newValue) {
//       this.selectedRange = newValue;
//     }
//   }
    },
  };
  </script>
  
  <style>
  .table_height .v-data-table__wrapper {
    height: calc(100vh - 360px);
  }
  
  .promotion-listing-tr:nth-child(even):hover {
    box-shadow: 0px 0px 10px #666666 !important;
    -webkit-box-shadow: 0px 0px 10px #666666 !important;
    -moz-box-shadow: 0px 0px 10px #666666 !important;
    background-color: #e3f2fd !important;
    position: relative;
    z-index: 5;
  }
  
  .promotion-listing-tr:nth-child(odd):hover {
    box-shadow: 0px 0px 10px #666666 !important;
    -webkit-box-shadow: 0px 0px 10px #666666 !important;
    -moz-box-shadow: 0px 0px 10px #666666 !important;
  }
  
  .custom_field_height v-input__control {
    max-height: 34px;
    height: 34px;
  }
  
  .custom_field_height .v-select__selection {
    max-width: 84%;
  }
  </style>
  